// breadcrumbsMap.js
export const breadcrumbsMap = {
    "/main/": {
        head: "menu-home",
        subRoutes: {
            "/dashboard$": "menu-second-dashboard",
            "/dashboard/edit": "menu-second-edit_dashboard",
            "/dashboard/edit/([0-9]+)$": "menu-second-edit_dashboard",
            "/sales/list$": "menu-second-sales",
            "/sales/expected$": "menu-second-sales-expected",
            "/sales/column$": "menu-second-sales-column",
            "/sales/company$": "menu-second-sales",
            "/overseas/list$": "menu-second-overseas_corporation",
            "/overseas/column$": "menu-second-overseas_corporation-column",
            "/exchange$": "menu-second-exchange",
            "/exchange/create$": "menu-second-exchange-create",
        },
    },
    "/order/": {
        head: "menu-order",
        subRoutes: {
            "orderRequest/list$": "menu-second-order-request",
            "orderRequest/detail/([0-9]+)$": "menu-second-order-request-detail",
            "orderRequest/create$": "menu-second-order-request-create",
            "orders/list$": "menu-second-orders",
            "orders/detail/.*$": "menu-second-orders-detail",
            "orders/create$": "menu-second-orders-create",
            "shipment/list$": "menu-second-shipment",
            "shipment/detail/([0-9]+)$": "menu-second-shipment-detail",
            "deadline/list$": "menu-second-deadline",
            "deadline/detail/.*$": "menu-second-deadline-detail",
            "invoice/list$": "menu-second-tax_invoice",
            "invoice/detail/([0-9]+)$": "menu-second-tax_invoice-detail",
            "receivables/list$": "menu-second-receivables",
            "receivables/detail/([0-9]+)$": "menu-second-receivables-detail",
        },
    },
    "/purchase/": {
        head: "menu-purchase",
        subRoutes: {
            "pcs/list$": "menu-second-purchase",
            "pcs/detail/([0-9]+)$": "menu-second-purchase-detail",
            "pcs/create$": "menu-second-purchase-create",
            "delivery/list$": "menu-second-delivery",
            "delivery/detail/([0-9]+)$": "menu-second-delivery-detail",
            "bond/list$": "menu-second-bond",
            "bond/detail/([0-9]+)$": "menu-second-bond-detail",
        },
    },
    "/product/": {
        head: "menu-product",
        subRoutes: {
            "/list$": "menu-second-product",
            "/detail/(.+)$": "menu-second-product-detail",
        },
    },
    "/inventory/": {
        head: "menu-inventory",
        subRoutes: {
            "inv/list$": "menu-second-inventory",
            "inv/create$": "menu-second-inventory-create",
            "inv/detail/([0-9]+)$": "menu-second-inventory-detail",
            "inv/history/([0-9]+)$": "menu-second-inventory-history",
            "barcode": "menu-second-barcode",
            "incoming/create$": "menu-second-incoming-create",
            "outgoing/create$": "menu-second-outgoing-create",
            "adjustment/create$": "menu-second-adjustment-create",
            "history": "menu-second-history",
            "analyze/list$": "menu-second-analyze",
            "analyze/formula$": "menu-second-analyze-formula",
        },
    },
    "/customer/": {
        head: "menu-customer",
        subRoutes: {
            "correspondent/list$": "menu-second-correspondent",
            "correspondent/detail/.*$": "menu-second-correspondent-detail",
            "correspondent/create$": "menu-second-correspondent-create",
            "correspondent/beforeApproval/.*$": "menu-second-correspondent-detail",
            "contact/list$": "menu-second-contact",
            "contact/detail/.*$": "menu-second-contact-detail",
            "contact/create$": "menu-second-contact-create",
            "project/list$": "menu-second-project",
            "project/detail/([0-9]+)$": "menu-second-project-detail",
            "project/create$": "menu-second-project-create",
            "tier/list$": "menu-second-tier",
            "tier/detail/([0-9]+)$": "menu-second-tier-detail",
        },
    },
    "/support/": {
        head: "menu-support",
        subRoutes: {
            "faq/list$": "menu-second-faq",
            "faq/detail/.*$": "menu-second-faq-detail",
            "faq/update/.*$": "menu-second-faq-update",
            "faq/create": "menu-second-faq-create",
            "qna/list$": "menu-second-qna",
            "qna/detail/.*$": "menu-second-qna-detail",
            "qna/create$": "menu-second-qna-create",
            "rma/list$": "menu-second-rma",
            "rma/detail/([0-9]+)$": "menu-second-rma-detail",
            "rma/update/([0-9]+)$": "menu-second-rma-update",
            "rma/create$": "menu-second-rma-create",
            "board/list$": "menu-second-board",
            "board/detail/.*$": "menu-second-board-detail",
            "board/update/.*$": "menu-second-board-update",
            "board/create$": "menu-second-board-create",
        },
    },
    "/manage/": {
        head: "menu-manage",
        subRoutes: {
            "account$": "menu-second-account",
            "account/list$": "menu-second-account",
            "account/detail/([0-9]+)$": "menu-second-account-detail", // 정규 표현식 사용
            "account/create$": "menu-second-account-create",
            "role$": "menu-second-roles",
            "role/list$": "menu-second-roles",
            "role/detail/([0-9]+)$": "menu-second-roles-detail",
            "role/create$": "menu-second-roles-create",
            "items": "menu-second-code",
            "mypage": "menu-second-mypage",
            "company": "menu-second-own_company",
        },
    },
};
  